import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';

/**
 * Route guard for /upload.
 * Accessible to any authenticated user (all roles can upload if needed).
 * Uploaders land here after login; admins can also access it directly.
 */
const UploaderRoute = () => {
  const { user, authLoading } = useAuth();

  if (authLoading) {
    return <div style={{ padding: 20 }}>Loading…</div>;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (user.emailVerified === false) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default UploaderRoute;
